import type { HTMLAttributes, JSX, ReactNode } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function Card({ className = '', children, ...props }: CardProps): JSX.Element {
  return (
    <div className={`fui-card ${className}`} {...props}>
      {children}
    </div>
  )
}

export interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  description?: string
  action?: ReactNode
}

export function CardHeader({
  title,
  description,
  action,
  className = '',
  ...props
}: CardHeaderProps): JSX.Element {
  return (
    <div className={`fui-card-header ${className}`} {...props}>
      <div>
        <h3 className="fui-card-title">{title}</h3>
        {description && <p className="fui-card-description">{description}</p>}
      </div>
      {action}
    </div>
  )
}

export interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function CardBody({ className = '', children, ...props }: CardBodyProps): JSX.Element {
  return (
    <div className={`fui-card-body ${className}`} {...props}>
      {children}
    </div>
  )
}

export interface CardFooterProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function CardFooter({ className = '', children, ...props }: CardFooterProps): JSX.Element {
  return (
    <div className={`fui-card-footer ${className}`} {...props}>
      {children}
    </div>
  )
}
